// src/components/Turmas/EstatisticaTurma.js
import React from "react";

const EstatisticaTurma = ({ turmasFiltradas, fechar }) => {
  const gerarEstatisticas = () => {
    const stats = Object.values(turmasFiltradas).flat().reduce((acc, aluno) => {
      const key = `${aluno.ano_criacao}-${aluno.classe}-${aluno.turma}`;
      if (!acc[key]) {
        acc[key] = {
          ano: aluno.ano_criacao || "-",
          classe: aluno.classe || "-",
          turma: aluno.turma || "-",
          total: 0,
          H: 0,
          M: 0
        };
      }
      acc[key].total += 1;
      if (aluno.genero === "M") acc[key].H += 1;
      else if (aluno.genero === "F") acc[key].M += 1;
      return acc;
    }, {});
    return Object.values(stats);
  };

  const estatisticas = gerarEstatisticas();

  return (
    <div>
      <h2>Estatísticas Gerais</h2>
      <div style={{ maxHeight: "600px", overflowY: "auto" }}>
        <table>
          <thead>
            <tr>
              <th>Ano</th>
              <th>Classe</th>
              <th>Turma</th>
              <th>Total</th>
              <th>H/M</th>
            </tr>
          </thead>
          <tbody>
            {estatisticas.map(stat => (
              <tr key={`${stat.ano}-${stat.classe}-${stat.turma}`}>
                <td>{stat.ano}</td>
                <td>{stat.classe}</td>
                <td>{stat.turma}</td>
                <td>{stat.total}</td>
                <td>{`H:${stat.H} / M:${stat.M}`}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <button onClick={fechar}>Fechar</button>
    </div>
  );
};

export default EstatisticaTurma;
